// extracted by mini-css-extract-plugin
module.exports = {"btn":"ob_LEP5JM","primary":"ob_jrVYYn","secondary":"ob_96yyop","tertiary":"ob_3iKSB3","quaternary":"ob_tdpOHr","cuetv":"ob_glSqwK"};